import React, { useEffect, useState } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import "./recharge.css";

function Recharge({ profile, getProfile }) {
    const [bank, setBank] = useState(null);
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [payment, setPayment] = useState([]);
    const [newMoney, setNewMoney] = useState(null);
    const [loading, setLoading] = useState(false);
    const [listBank, setListBank] = useState(null);
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getbank`, {})
            .then((res) => {
                setBank(res.data.data);
            })
            .catch((err) => setBank(null));
        axios
            .get(`${process.env.REACT_APP_API_URL}/bank/getbanks`, {})
            .then((res) => {
                setListBank(res.data.data);
            })
            .catch((err) => setBank(null));
        axios
            .get(`${process.env.REACT_APP_API_URL}/setting/get`, {})
            .then((res) => {
                if (setting != res.data.data[0]) {
                    setSetting(res.data.data[0]);
                    localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
                }
            })
            .catch((err) => setSetting(null));
        axios
            .get(`${process.env.REACT_APP_API_URL}/payment/paymentus`, {})
            .then((res) => {
                if (res.data.data) setPayment(res.data.data);
            })
            .catch((err) => setPayment(null));
    }, []);

    // Đặt mặc định là 0 (Nạp Auto)
    const [activeOption, setActiveOption] = useState(0);
    const handleOptionClick = (option) => {
        setActiveOption(option);
    };

    const onSubmit = (data) => {
        // Lấy số điểm người dùng nhập vào (VD: 100)
        const inputPoint = Number(data.money.replaceAll(".", "").replaceAll(",", ""));
        
        // Nhân với 1000 để ra số tiền thật gửi lên server (VD: 100 * 1000 = 100000)
        const realMoney = inputPoint * 1000;

        const formData = {
            money: realMoney,
            type_payment: "NẠP",
            detail: data.detail,
            status_payment: "Pending",
            user: profile._id
        };

        if (inputPoint <= 0 || isNaN(inputPoint)) {
            swal("Thông báo", "Vui lòng nhập số điểm hợp lệ", "error");
            return false;
        }
        if (realMoney < setting?.minnap) {
            swal("Chú ý", `Số điểm nạp tối thiểu là ${(setting?.minnap / 1000).toLocaleString('vi-VN')} Điểm`, "warning");
            return false;
        }
        if (realMoney > setting?.maxnap) {
            swal("Chú ý", `Số điểm nạp tối đa là ${(setting?.maxnap / 1000).toLocaleString('vi-VN')} Điểm`, "warning");
            return false;
        }

        // Logic Nạp tự động (Auto)
        if (activeOption == 0) {
            if (!listBank || listBank.length === 0) {
                swal("Thông báo", "Hệ thống đang cập nhật cổng thanh toán, vui lòng thử lại sau giây lát!", "warning");
                return false;
            }

            // Chọn ngẫu nhiên 1 ngân hàng từ danh sách trả về
            const randomBank = listBank[Math.floor(Math.random() * listBank.length)];
            const finalBankCode = randomBank.code;

            // MỞ TAB TRẮNG NGAY LẬP TỨC ĐỂ KHÔNG BỊ CHẶN
            const paymentTab = window.open('about:blank', '_blank');
            if (paymentTab) {
                paymentTab.document.write(
                    "<h3 style='font-family: sans-serif; text-align: center; margin-top: 50px; color: #444;'>" +
                    "Đang khởi tạo cổng thanh toán an toàn, vui lòng đợi..." +
                    "</h3>"
                );
            }

            setLoading(true);
            axios
                .post(`${process.env.REACT_APP_API_URL}/bank/createTrans`, {
                    amount: realMoney,
                    type: finalBankCode // Gửi mã bank đã được random
                })
                .then((res) => {
                    // Chuyển hướng tab trắng sang URL thanh toán
                    if (paymentTab) {
                        paymentTab.location.href = res.data.data.url;
                    }
                    setLoading(false);
                    swal("Thành công", "Vui lòng hoàn tất thanh toán ở tab mới.", "success");
                })
                .catch((err) => {
                    // Nếu lỗi thì đóng luôn tab trắng
                    if (paymentTab) {
                        paymentTab.close();
                    }
                    setLoading(false);
                    swal("Thất bại", err.response?.data?.message != "internal server error" ? err.response?.data?.message : "Ngân hàng bảo trì, vui lòng thử lại sau", "error");
                });
        } 
        // Logic Nạp thủ công (Các tab còn lại)
        else {
            if (payment) {
                const count = payment.filter((obj) => obj.status_payment === "Pending" && obj.type_payment === "NẠP");
                if (count.length > 1) {
                    swal("Thông báo", `Bạn đang có ${count.length} lệnh nạp điểm chưa xử lý, không thể tạo thêm lệnh nạp.`, "error");
                    return false;
                }
            }
            setLoading(true);
            axios
                .post(`${process.env.REACT_APP_API_URL}/payment/withDraw`, formData)
                .then((res) => {
                    swal("Nạp điểm thành công", "Điểm sẽ được cộng trong vòng 5 phút. Nếu quá lâu vui lòng liên hệ CSKH để được xử lý.", "success");
                    getProfile();
                    setLoading(false);
                })
                .catch((err) => {
                    swal("Thất bại", err.response?.data?.message != "internal server error" ? err.response?.data?.message : "Đã xảy ra lỗi", "error");
                    setLoading(false);
                });
        }
    };

    return (
        <>
            <style>{`
                .recharge-wrapper-new {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                }
                
                .menu-recharge-top {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    gap: 15px;
                    margin-bottom: 25px;
                    border-bottom: 2px solid #f0f0f0;
                    padding-bottom: 20px;
                }
                .menu-item-recharge-top {
                    flex: 1;
                    min-width: 160px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    padding: 12px;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    background: #f9f9f9;
                    cursor: pointer;
                    transition: all 0.2s ease-in-out;
                    position: relative;
                }
                .menu-item-recharge-top img {
                    width: 28px;
                    height: 28px;
                    object-fit: contain;
                }
                .menu-item-recharge-top span {
                    font-size: 14px;
                    font-weight: 600;
                    color: #555;
                }
                .menu-item-recharge-top:hover {
                    background: #fff;
                    border-color: #00b459;
                }
                .menu-item-recharge-top.active {
                    background: #fff;
                    border-color: #00b459;
                    box-shadow: 0 4px 10px rgba(0, 180, 89, 0.15);
                }
                .menu-item-recharge-top.active span {
                    color: #00b459;
                }
                .menu-item-recharge-top.active::after {
                    content: "✔";
                    position: absolute;
                    bottom: -1px;
                    right: -1px;
                    background: #00b459;
                    color: #fff;
                    font-size: 10px;
                    padding: 2px 6px;
                    border-radius: 4px 0 8px 0;
                }

                .content-recharge-full {
                    width: 100%;
                    background: #fff;
                    padding: 10px 0;
                }
                .content_bank {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    margin-bottom: 25px;
                }
                .item-bank {
                    border: 1px solid #e0e0e0;
                    background: #fafafa;
                    border-radius: 8px;
                    padding: 20px;
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    font-size: 15px;
                }

                .ipadd {
                    width: 300px;
                    padding: 10px 15px;
                    border: 1px solid #ccc;
                    border-radius: 6px;
                    outline: none;
                    font-size: 15px;
                }
                .ipadd:focus {
                    border-color: #00b459;
                }
                .btn-submit {
                    padding: 10px 25px;
                    background-color: #00b459;
                    color: #fff;
                    border: none;
                    border-radius: 6px;
                    font-weight: bold;
                    cursor: pointer;
                    font-size: 15px;
                }
                .btn-submit:hover {
                    background-color: #00964a;
                }
                .huongdan {
                    background: #fff3e0;
                    border-left: 4px solid #ff9800;
                    padding: 15px 20px;
                    border-radius: 4px;
                    margin-top: 30px;
                }
                .huongdan .title {
                    font-weight: bold;
                    color: #e65100;
                    margin-bottom: 10px;
                }
                .huongdan ul {
                    margin: 0;
                    padding-left: 20px;
                    color: #555;
                    line-height: 1.6;
                }
                .huongdan ul li {
                    margin-bottom: 5px;
                }
                
                @media (max-width: 768px) {
                    .menu-recharge-top {
                        flex-direction: column;
                    }
                    .ipadd {
                        width: 100%;
                        margin-bottom: 10px;
                    }
                }
            `}</style>

            {loading === true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}

            <div className="recharge-wrapper-new">
                {profile && (
                    <>
                        <div className="menu-recharge-top">
                            {/* Chức năng Nạp Auto (index = 0) */}
                            <div className={`menu-item-recharge-top ${activeOption == 0 ? "active" : ""}`} onClick={() => handleOptionClick(0)}>
                                <img src={require("../../../image/banktransfer.png")} alt="Nạp Auto" />
                                <span>Nạp Auto</span>
                            </div>

                          {/* Bỏ comment để dùng các tab nạp thủ công
                          <div className={`menu-item-recharge-top ${activeOption == 1 ? "active" : ""}`} onClick={() => handleOptionClick(1)}>
                                <img src={require("../../../image/banktransfer.png")} alt="Ngân hàng" />
                                <span>Chuyển khoản thủ công</span>
                            </div>
                            
                            <div className={`menu-item-recharge-top ${activeOption == 2 ? "active" : ""}`} onClick={() => handleOptionClick(2)}>
                                <img src={require("../../../image/momo.jpeg")} alt="Momo" />
                                <span>Ví Momo</span>
                            </div>
                            
                            <div className={`menu-item-recharge-top ${activeOption == 3 ? "active" : ""}`} onClick={() => handleOptionClick(3)}>
                                <img src={require("../../../image/tether.png")} alt="Ví điện tử" />
                                <span>Ví USDT</span>
                            </div>*/}
                        </div>

                        <div className="content-recharge-full">
                            <div className="top_title" style={{ marginBottom: "15px", fontWeight: "bold", fontSize: "18px", borderLeft: "4px solid #00b459", paddingLeft: "10px" }}>
                                <div className="txt">Thông tin nạp điểm</div>
                            </div>
                            
                            {/* VIEW THỦ CÔNG: NGÂN HÀNG */}
                            {activeOption == 1 && (
                                <div className="content_bank">
                                    {bank &&
                                        bank?.map((item, index) =>
                                            item.isShow && item.name_bank.toLowerCase() != "momo" && item.name_bank.toLowerCase() != "usdt" ? (
                                                <div key={index} className="item-bank">
                                                    {item.qr && (
                                                        <div style={{ marginBottom: "15px" }}>
                                                            <img src={item.qr} style={{ width: "150px", borderRadius: "8px" }} alt="QR Code" />
                                                        </div>
                                                    )}
                                                    <div>Tên ngân hàng: <b style={{ color: "red" }}>{item.name_bank}</b></div>
                                                    <div>Số tài khoản: <b>{item.stk}</b></div>
                                                    <div>Tên người nhận: <b>{item.fullname}</b></div>
                                                    <div>Nội dung chuyển khoản: <b>{item.title} {profile?.username}</b></div>
                                                </div>
                                            ) : null
                                        )}
                                </div>
                            )}

                            {/* VIEW THỦ CÔNG: MOMO */}
                            {activeOption == 2 && (
                                <div className="content_bank">
                                    {bank &&
                                        bank?.map((item, index) =>
                                            item.isShow && item.name_bank.toLowerCase() == "momo" ? (
                                                <div key={index} className="item-bank">
                                                    {item.qr && (
                                                        <div style={{ marginBottom: "15px" }}>
                                                            <img src={item.qr} style={{ width: "150px", borderRadius: "8px" }} alt="QR Momo" />
                                                        </div>
                                                    )}
                                                    <div>Số Momo: <b>{item.stk}</b></div>
                                                    <div>Tên người nhận: <b>{item.fullname}</b></div>
                                                    <div>Nội dung chuyển khoản: <b>{item.title} {profile?.username}</b></div>
                                                </div>
                                            ) : null
                                        )}
                                </div>
                            )}

                            {/* VIEW THỦ CÔNG: USDT */}
                            {activeOption == 3 && (
                                <div className="content_bank">
                                    {bank &&
                                        bank?.map((item, index) =>
                                            item.isShow && item.name_bank.toLowerCase() == "usdt" ? (
                                                <div key={index} className="item-bank">
                                                    {item.qr && (
                                                        <div style={{ marginBottom: "15px" }}>
                                                            <img src={item.qr} style={{ width: "150px", borderRadius: "8px" }} alt="QR USDT" />
                                                        </div>
                                                    )}
                                                    <div>Địa chỉ ví: <b>{item.stk}</b></div>
                                                    <div style={{ marginTop: "10px", opacity: "0.85" }}>{item.title}</div>
                                                </div>
                                            ) : null
                                        )}
                                </div>
                            )}

                            {/* FORM NHẬP ĐIỂM DÙNG CHUNG */}
                            <>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
                                        <label style={{ minWidth: "150px", fontSize: "15px", fontWeight: "bold", color: "#333" }}>
                                            Nhập số điểm nạp<br/>
                                            <small style={{ color: "#888", fontWeight: "normal" }}>(1 Điểm = 1.000 VNĐ)</small>
                                        </label>
                                        <input
                                            className="ipadd"
                                            type="text"
                                            value={newMoney || ""}
                                            {...register("money")}
                                            onClick={() => setNewMoney(null)}
                                            onChange={(e) => {
                                                const val = e.target.value.replaceAll(".", "").replaceAll(",", "");
                                                if (!isNaN(val) && val !== "") {
                                                    setNewMoney(Number(val).toLocaleString("vi-VN"));
                                                } else {
                                                    setNewMoney("");
                                                }
                                            }}
                                            placeholder="Nhập số điểm muốn nạp"
                                        />
                                        <button type="submit" className="btn-submit">
                                            Xác nhận nạp
                                        </button>
                                    </div>
                                    <div style={{ display: "none" }}>
                                        <input className="ipadd" type="text" {...register("detail")} placeholder="Nhập mã giao dịch ngân hàng" defaultValue="Nạp" />
                                    </div>
                                </form>

                                <div className="huongdan">
                                    <div className="title">Hướng dẫn nạp điểm</div>
                                    {activeOption == 0 ? (
                                        <ul>
                                            <li><b>Bước 1:</b> Nhập số điểm muốn nạp (1 điểm = 1.000 VNĐ).</li>
                                            <li><b>Bước 2:</b> Bấm Xác nhận. Hệ thống sẽ tự động điều phối ngân hàng xử lý ở tab mới.</li>
                                            <li>Sau khi hoàn tất thanh toán, điểm sẽ được cộng tự động vào tài khoản của bạn.</li>
                                        </ul>
                                    ) : (
                                        <ul>
                                            <li>Chuyển khoản đến thông tin ngân hàng/Momo ở trên.</li>
                                            <li>Vui lòng ghi đúng nội dung chuyển khoản gồm có cả tên đăng nhập của bạn</li>
                                            <li>
                                                Sau khi chuyển khoản thành công quý khách điền <b>số điểm</b> (1 điểm tương ứng 1.000 VNĐ) vào ô nhập điểm và bấm xác nhận, điểm sẽ được cộng trong vòng 5 phút.
                                            </li>
                                            <li>Nếu sau 5 phút điểm không tự động cộng vào tài khoản, vui lòng liên hệ CSKH để được hỗ trợ.</li>
                                        </ul>
                                    )}
                                </div>
                            </>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default Recharge;